<template>
  <div
    class="loader-container"
    :class="{ 'loader-absolute': absolute }"
    :style="`background: ${overlayBackground}`"
  >
    <v-progress-circular
      :color="color"
      :indeterminate="indeterminate"
      :size="size"
      :width="width"
    />
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    absolute: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
    },
    indeterminate: {
      type: Boolean,
      default: true,
    },
    overlayBackground: {
      type: String,
      default: "transparent",
    },
    size: {
      type: [Number, String],
      default: 32,
    },
    width: {
      type: [Number, String],
      default: 2,
    },
  },
};
</script>

<style lang="scss" scoped>
.loader-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.loader-absolute {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
}
</style>
